import { useState, useEffect } from 'react';

export function ManageCompteur(interaction) {
    const [isRunning, setIsRunning] = useState(false);
    const [startTime, setStartTime] = useState(null);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [counter, setCounter] = useState('00:00:00.00');
    const [afficherCompteur, setAfficherCompteur] = useState(true);

    const startCountdownTimer = () => {
        if (!isRunning) {
            setStartTime(Date.now() - elapsedTime);
            setIsRunning(true);
        }
    };

    const stopCountdownTimer = () => {
        setIsRunning(false);
    };

    useEffect(() => {
        let intervalId;
        if (isRunning) {
            intervalId = setInterval(() => {
                const now = Date.now();
                setElapsedTime(now - startTime);
            }, 100); // Mise à jour toutes les 100 millisecondes
        }
        return () => clearInterval(intervalId);
    }, [isRunning, startTime]);

    useEffect(() => {
        const formatTime = (milliseconds) => {
            const totalSeconds = Math.floor(milliseconds / 1000);
            const tenths = Math.floor((milliseconds % 1000) / 100);
            const mins = Math.floor((totalSeconds % 3600) / 60);
            const secs = totalSeconds % 60;
            const ran = milliseconds === 0 ? 0 : Math.floor(Math.random() * 10);
            return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}:${tenths}${ran}`;
        };

        setCounter(formatTime(elapsedTime));
    }, [elapsedTime]);

    useEffect(() => {
        if (interaction.max_recording_time && elapsedTime >= interaction.max_recording_time * 1000) {
            setIsRunning(false);
        }
    }, [elapsedTime, interaction.max_recording_time]);

    return {
        counter,
        startCountdownTimer,
        stopCountdownTimer,
        afficherCompteur,
        setAfficherCompteur
    };
}